import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import config from '../config';

const DevFooter: React.FC = () => {
  const navigate = useNavigate();
  const auth0 = useAuth0();
  const isAdmin = auth0.user?.email === 'weezilla@gmail.com' && auth0.user?.sub?.startsWith('google-oauth2|');

  const simulateNewUserLogin = async () => {
    try {
      // Clear local storage first
      localStorage.clear();
      // Logout from Auth0 - this will trigger a fresh login
      auth0.logout({ logoutParams: { returnTo: window.location.origin } });
    } catch (error) {
      console.error('Error simulating new user:', error);
    }
  };

  const handleEditAllChars = async () => {
    try {
      const token = await auth0.getAccessTokenSilently();
      
      // Update all characters to have the current user as owner
      await axios.post(
        `${config.api.baseURL}/api/dev/characters/update-all-owners`, 
        {
          userSub: auth0.user?.sub,
          displayName: auth0.user?.name || auth0.user?.email?.split('@')[0] || 'Unknown'
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Refresh the character list
      window.dispatchEvent(new Event('character-added'));
      // Navigate to My Characters page
      navigate('/my-characters');
    } catch (error) {
      console.error('Error updating character ownership:', error);
    }
  };

  if (!isAdmin) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: 'primary.dark',
        color: 'white',
        p: 1,
        display: 'flex',
        justifyContent: 'center',
        gap: 2,
        zIndex: 1100
      }}
    >
      <Button
        variant="contained"
        color="secondary"
        onClick={simulateNewUserLogin}
        size="small"
      >
        Simulate New User Login
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate('/dev/users')}
        size="small"
      >
        User Management
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate('/dev/characters')}
        size="small"
      >
        Edit All Characters
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate('/dev/roadmap')}
        size="small"
      >
        Edit Roadmap
      </Button>
    </Box>
  );
};

export default DevFooter; 